// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false

// import App from './App.vue'

// For vxe-table
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
// For internationalism
import VueI18n from 'vue-i18n'
// import zhCN from 'vxe-table/lib/locale/lang/zh-CN'
import enUS from 'vxe-table/lib/locale/lang/en-US'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

const messages = {
  en_US: {
    ...enUS
  }
}


Vue.use(VueI18n);
Vue.use(ElementUI);

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import router from './router/index'

// 设置语言
locale.use(lang)

const i18n = new VueI18n({
  locale: 'en_US',
  messages,
})

Vue.use(VXETable, {
  // 对组件内置的提示语进行国际化翻译
  i18n: (key, args) => i18n.t(key, args)
})



new Vue({
  el: '#app',
  i18n,
  render: h => h(App),
  components: { App },
  template: '<App/>',
  router,
})

// 每次路由切换后，自动滚动到页面顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});




// WEBPACK FOOTER //
// ./src/main.js